import styled, { css } from 'styled-components';

const Marker = styled.div`
  ${({ $background, $sizeIcon }) =>
    $background.indexOf('.svg') > -1
      ? css`
          width: ${$sizeIcon}px;
          height: ${$sizeIcon}px;
          border-radius: 0% 50% 50% 50%;
          background-image: url(/images/${$background});
          background-size: 100% 100%;
          transform: rotate(-135deg);
          transform-origin: top left;
        `
      : css`
          width: ${$sizeIcon}px;
          height: ${$sizeIcon}px;
          border-radius: 0% 50% 50% 50%;
          background: ${$background};
          transform: rotate(-135deg);
          transform-origin: top left;
        `}
  position: absolute;
  left: 50%;
  top: 50%;
  margin: 0;

  :after {
    ${({ $letter }) =>
      $letter &&
      css`
        content: '${$letter}';
      `}
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(135deg);
    font-size: 12px;
    font-weight: bold;
    color: ${({ $color }) => $color || '#fff'};
    pointer-events: none;
  }
  :hover {
    cursor: pointer;
  }
`;

export default Marker;
